// extracted by mini-css-extract-plugin
export default {"limitBannerContainer":"PropertiesHeaderPageTabs-module__limitBannerContainer--Jt5td"};